import IframeRenderer from "../../components/iframeRenderer";

const Dashboard = (props: any) => {
  const iframeLink = '//assets.finkraft.ai/open-view/103074000017662550/9739f48f5dcd2b4df8125fe1f9ce978c';
  return (
    <IframeRenderer iframeLink={iframeLink} />
  )
};

export default Dashboard;